//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import Select from 'react-select';
// Alertas
import Swal from 'sweetalert2'

//Estilos
// import './FormNivel1.css';
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import subsistemaContext from '../../context/subsistemaContex/subsistemaContext';
import activoContext from '../../context/activoContex/activoContex';


const FormSubsistema = ({ data, minimizar, sistemaSelected, optionsSistema, addOrEditForm, handleChangeSubsistema}) => {
    //data corresponde a la informacion de subsistema recibido, caso que sea {}, setea un nuevo subsistema.

    const {actualizaractivoList} = useContext(activoContext)
    const sContext = useContext(subsistemaContext);
    const {actualizarSubsistema, agregarSubsistema, modificarSubsistema,eliminarSubsistema} = sContext;
    const [subsistema,setSubsistema] = useState((addOrEditForm) ? {codSubsistema: '', name: ''} : {...data})
    //const [subsistema,setSubsistema] = useState((Object.keys(data).length > 0 && !addOrEditForm) ? {...data} : {codSubsistema: '', name: '', sistemaID: data?.sistemaID})
    
    const titulo = (addOrEditForm) ? 'Agregar' : 'Modificar';

    //Funcion de validacion
    const validacion =  () => {
        const newErrors = {};
        if (subsistema.codSubsistema === '' || subsistema.codSubsistema === undefined) return newErrors.nombre = 'El código debe ser colocado'
        if (subsistema.name === '' || subsistema.name === undefined) return newErrors.codigo = 'El nombre debe ser colocado'
        
        return '';
    };

    const handlerGenerar = async ()  => {
        const errorAxi = validacion();
        
        if ( errorAxi === "" ) {

            try {
                const dato = { sistemaID: sistemaSelected._id, name: subsistema.name, codSubsistema: subsistema.codSubsistema}
                const res = await agregarSubsistema(dato);
                
                if (res !== null) {
                    Swal.fire({
                        title: `Se guardo un nuevo Subsistema`,
                        icon: 'success',
                        text: `Código: ${res.codSubsistema} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizaractivoList();
                    actualizarSubsistema();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el nombre o el código de subsistema",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerModificar = async () => {
       
        const errorAxi = validacion();

        if (errorAxi === "") {
            try {
                const dato = {
                    id: data._id,
                    name: subsistema.name,
                    sistemaID: sistemaSelected._id,
                }
                // await setData(dato);
                const res = await modificarSubsistema(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se modificó el Subsistema`,
                        icon: 'success',
                        text: `Código: ${res.codSubsistema} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizaractivoList();
                    actualizarSubsistema();
                    minimizar({...dato, label: res.name, value:res.name});
                    
                    let newSubsys = {
                        _id: res._id,
                        codSubsistema: res.codSubsistema,
                        name: res.name,
                        label: res.name,
                        value: res.name,
                        sistemaID: res.sistemaID
                    }
                    handleChangeSubsistema(newSubsys);
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el nombre o el código del Subsistema",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
 
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar este Subsistema?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data._id
                const resp = await eliminarSubsistema(id);
                if(resp === "No se puede borrar subsistema porque contiene componentes"){
                    Swal.fire({
                        title: `No se puede borra el subsistema`,
                        icon: 'warning',
                        text: `Para poder eliminar el subsistema no tiene que tener componenetes`,
                        showConfirmButton: true,
                        allowEnterKey: true
                        
                    })
                    minimizar(null);
                }else{
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `El Subsistema fue borrado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    let subSistema ={
                        _id: "",
                        codSubsistema: "",
                        name: "",
                        label: "",
                        value: "",
                        sistemaID: sistemaSelected._id
                    };
                    handleChangeSubsistema(subSistema);
                    actualizaractivoList();
                    actualizarSubsistema();
                    minimizar(null);
                }
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                minimizar();
            }
            });
    }

    const handleChange = (e) => {
        setSubsistema({...subsistema,[e.target.name]:e.target.value});
    }

    return (
        <div className='container-group-form'>
                <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                    {titulo} Subsistema
                </div>

                <div className='container-form'>
                    <div className='label-form-group'>Código: </div> 
                    <input disabled={!addOrEditForm} name='codSubsistema'  value={subsistema.codSubsistema} className='label-form-group-data' 
                    onChange={data => handleChange(data)} />
                </div>

                <div className='container-form'>
                    <div className='label-form-group'>Nombre: </div>
                    <input value={subsistema.name}className='label-form-group-data' name='name'
                        onChange={data => handleChange(data)}/>
                </div>

                <div className='container-form'>
                <div className='label-form-group'>Sistema: </div>
                <Select
                    styles={{
                        input: (base) => ({
                            ...base,
                            width: "100%",
                            padding: ".4rem",
                            borderRadius: ".5rem",
                            fontSize: "1rem",
                            transition: "border-color .5s"
                        })
                    }}
                    isDisabled={true}
                    placeholder="Elija el sistema que corresponda..."
                    options={optionsSistema}
                    value={sistemaSelected}
                    
                />
            </div>

                <div className='container-btn-group'>
                    <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} 
                        onClick={(addOrEditForm) ? handlerGenerar : handlerModificar}>{titulo}</button> 
                    {(!addOrEditForm) && (<button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>)}
                    <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                </div>
            </div>
    )
}

export default FormSubsistema;